import { initialState } from "./state";

export const Section = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SECTION": {
      return Object.assign({}, state, {
        Section: action.data
      });
    }
    default:
      return state;
  }
};
